import { bankServices } from "../../config/axios";
import {
    VIEWUSERDETAILS_SUCCESS,
    VIEWUSERDETAILS_FAILED,
    RESET_VIEWUSERDETAILS,
    LOADING_VIEWUSERDETAILS_,
    VIEWUSERDETAILS_NETWORKERROR,
} from '../types/index';

const resetviewUserDetails = () => {
    return { type: RESET_VIEWUSERDETAILS };
};

const viewUserDetails = (userData, authTokenIs) => async (dispatch) => {
    dispatch({ type: LOADING_VIEWUSERDETAILS_ });
    await bankServices
        .post("viewuserdetails", userData, { headers: { AuthToken: authTokenIs } })
        .then((res) => {
            switch (res.data.status) {
                case "success":
                    dispatch(success(res.data));
                    break;
                default:
                    dispatch(failed(res.data));
                    break;
            }
        })
        .catch((err) => {
            dispatch({
                type: VIEWUSERDETAILS_NETWORKERROR,
                payload: err
            });
        });
}

function success(data) {
    return {
        type: VIEWUSERDETAILS_SUCCESS,
        payload: data
    };
}
function failed(data) {
    return {
        type: VIEWUSERDETAILS_FAILED,
        payload: data
    };
}

export { resetviewUserDetails, viewUserDetails }